import { useEventListener, useIdle } from "@vueuse/core";
/**
 * ScholarTrip 智能監控插件 (Retention Engine - Production Ready)
 * 解決方案：
 * 1. 精確控制觸發條件，避免過度打擾用戶。
 * 2. 加入 sessionStorage 防護，確保同一 Session 不會瘋狂彈出。
 */
export default defineNuxtPlugin((nuxtApp) => {
  const isRescueActive = useState("telemetry:rescue-active", () => false);
  const rescueReason = useState("telemetry:rescue-reason", () => "");
  // 3 分鐘不操作視為閒置 (猶豫)
  const { idle } = useIdle(3 * 60 * 1000);
  // 防干擾機制：每個 Session 只挽留一次
  const checkCanTrigger = () => {
    if (import.meta.server) return false;
    const hasTriggered = sessionStorage.getItem("scholartrip_rescued");
    return !hasTriggered && !isRescueActive.value;
  };
  const markTriggered = () => {
    sessionStorage.setItem("scholartrip_rescued", "true");
  };
  watch(idle, (isIdle) => {
    const route = useRoute();
    if (isIdle && route.path.includes("checkout") && checkCanTrigger()) {
      rescueReason.value = "結帳遇到困難嗎？我們的客服專家隨時在線為您服務。";
      isRescueActive.value = true;
      markTriggered();
    }
  });
  nuxtApp.hook("app:mounted", () => {
    useEventListener(window, "mouseout", (e: MouseEvent) => {
      const route = useRoute();
      // 偵測 Exit-Intent：滑鼠快速移向視窗頂端 (準備關閉標籤)
      if (e.clientY <= 0 && checkCanTrigger()) {
        if (route.path.includes("search")) {
          rescueReason.value =
            "等等！您可能即將錯失這些經人工驗證的學生特惠票價。";
          isRescueActive.value = true;
          markTriggered();
          console.info(
            "[ScholarTrip Telemetry] Search page exitintent captured.",
          );
        } else if (route.path.includes("checkout")) {
          rescueReason.value = "只差最後一步了！機位有限，建議您先完成預訂。";
          isRescueActive.value = true;
          markTriggered();
          console.info(
            "[ScholarTrip Telemetry] Checkout page exitintent captured.",
          );
        }
      }
    });
  });
  return {
    provide: {
      telemetry: {
        trigger: (reason: string) => {
          rescueReason.value = reason;
          isRescueActive.value = true;
        },
        close: () => {
          isRescueActive.value = false;
        },
      },
    },
  };
});
